import RadioGroupModule from './radio-group.module'

export default RadioGroupModule
